let url = "";

// Em dev local (npm start) usa o backend local por padrão.
// Em produção/Docker: lê de window._env_.API_URL, injetado em tempo de execução
// pelo entrypoint do container (docker/env.sh) — assim dá pra trocar de LAN pra
// domínio público sem precisar rebuildar a imagem, só reiniciar o container.
if (process.env.NODE_ENV === 'development') {
    url = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
} else {
    url = (window._env_ && window._env_.API_URL) || process.env.REACT_APP_API_URL || "https://api.agrotec.laonlabs.com";
}

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin"
};